module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "author"
  }, [_vm._v("14")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_c('span', [_vm._v("Meiner")]), _vm._v(" Begierden sind\nviele, mein"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nSchrei heischt Mitleid, aber du hast mich"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nnoch immer gerettet durch hartes Verweigern,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nmit dieser strengen Gnade hast"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\ndu mein Leben durch und durch gewirkt.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Tag für Tag machst du mich würdig"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nder einfachen, großen Gaben, die du mir"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nungebeten gabst – des Himmels, des"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nLichts, dieses Leibes, Lebens und Geistes"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\n– und rettest mich aus der Gefahr des"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nÜbermaßes der Wünsche.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Es gibt Zeiten, wo träge ich zögre und"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nandre, wo ich erwache und eile, mein"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nZiel zu suchen; doch grausam birgst du"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\ndich vor mir.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Tag für Tag machst du mich würdig deines"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nvollen Empfangs, indem du dich immer"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nversagst und rettest mich vor der Gefahr"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nder schwachen, unsicheren Wünsche. "), _c('a', {
    attrs: {
      "id": "page19",
      "title": "mabarosa/wedi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2799bce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0015.vue
// module id = 99
// module chunks = 0